import React, { useState } from "react";
import dynamic from "next/dynamic";
import { TechnologyListBlock } from "../index";

// Dynamic imports
import Section from "@/Components/LayoutComponents/Section";
import { toWebp } from "@/utils/common";
const TechnologyCard = dynamic(() => import("./TechnologyCard"), {
  ssr: true,
});

export interface TechnologyListProps {
  data: TechnologyListBlock;
}

const TechnologyList: React.FC<TechnologyListProps> = ({ data,
 }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <Section>
      <div className="container">
        <div className="flex lg:flex-row flex-col g:gap-3 gap-8 justify-between items-center lg:text-start text-center">
          <h2 className="xl:max-w-[810px] lg:max-w-[562px] w-full flex-[0_0_auto] xl:text-heading-1 lg:text-heading-2 text-heading-1 text-primary-text font-bold">
            {data?.title}
          </h2>
          <p className="text-subtitle-2 font-regular text-secondary-text xl:max-w-[286px] lg:max-w-[266px]">
            {data?.sub_title}
          </p>
        </div>
        <div className="xl:mt-20 lg:mt-10 mt-0">
          {data.cards?.map((card, index) => (
            <TechnologyCard
              key={card?.id}
              index={card?.id}
              openIndex={openIndex}
              setOpenIndex={setOpenIndex}
              className={`${index === 0 ? "xl:mt-0" : "xl:mt-[80px] md:mt-[56px]"}`}
              variant={(index % 2 === 0 ? "blue" : "green") as "blue" | "green"}
              image={toWebp(card?.images?.data?.attributes?.url)}
              heading={card?.title}
              technologies={card?.technologies?.map((tech) => ({
                id: tech.id,
                language: tech?.language,
                image: tech?.Image,
              }))}
            />
          ))}
        </div>
      </div>
    </Section>
  );
};
export default TechnologyList;